import { useTranslation } from 'react-i18next'
import { useRightPanelHopTimus } from '../../rightPanelContext'
import useTypedExample from './useTypedExample'

const useHopTimusAskLine = () => {
  const { t } = useTranslation()
  const { ask } = useRightPanelHopTimus()
  const examples = t('common:hop_timus_ask_examples', { returnObjects: true }) as string[]
  const example = useTypedExample(Array.isArray(examples) ? examples : [])

  return {
    label: t('common:hop_timus_ask_placeholder'),
    example,
    shortcut: t('common:hop_timus_shortcut'),
    onAsk: ask,
  }
}

export default useHopTimusAskLine
